export function modalSS() {
    window.addEventListener("load", () => {
        const showButtonsSS = document.querySelectorAll(".showDialogSS");
        const favDialogSS = document.getElementById("favDialogSS");

        if (!favDialogSS) return; // favDialogSSが存在しない場合は終了

        showButtonsSS.forEach((item) => {
            item.addEventListener("click", (e) => {
                const button = e.target.closest(".showDialogSS");
                if (!button) return;

                const id = button.getAttribute("data-id");
                if (!id) return;

                const content = document.querySelector(`#${id}`).content;
                if (!content) return;

                const clone = document.importNode(content, true);
                const wrap = document.querySelector("#favDialogSS .content-main");

                while (wrap.firstChild) {
                    wrap.removeChild(wrap.firstChild);
                }

                const services = JSON.parse(e.target.dataset.services);

                clone.querySelectorAll("[data-shop-service]").forEach((item) => {
                    const service = item.dataset.shopService;
                    if (!services.includes(service)) {
                        item.remove();
                    }
                });

                wrap.appendChild(clone);
                favDialogSS.showModal();
            });
        });

        favDialogSS.addEventListener("click", (e) => {
            if (e.target === e.currentTarget || e.target.tagName.toLowerCase() === "form") {
                favDialogSS.close();
            }
        });
    });
}
